import { ConflictsAction, CompleteSearchStatuses, SearchVersion, QuickSearch, SearchSummary, isSearchSummary } from "aderant-conflicts-models";
import { BlobStorageConnector } from "../BlobStorageConnector/BlobStorageConnector";
import { FunctionAppContext } from "../..";
import { getReviewerOptions } from "./GetReviewerOptions";

export async function canReviewerViewSearch(context: FunctionAppContext, searchVersion: SearchVersion | QuickSearch | SearchSummary): Promise<boolean> {
    // Fetch reviewer statuses from blob storage
    const blobData = await getReviewerOptions(context);
    const validStatuses = blobData.hitShared;

    // Check if the user has reviewer permissions
    const canViewSearchesSharedToUser = await context.currentUserHasPermission(ConflictsAction.ViewSearchesAndHitsSharedToUser);
    if (!canViewSearchesSharedToUser) {
        return false; // Return false if the user does not have permission
    }

    // Check if the search is shared with the user
    const isSearchSharedToUser = searchVersion.sharedToUserIds?.includes(context.currentUserId) ?? false;

    const completeStatuses = Object.values(CompleteSearchStatuses);

    // Ensure the search is not in a complete state
    const isIncompleteState = !completeStatuses.some((status) => searchVersion.status === status);

    // For SearchSummary, ignore hit validation; for others, validate hits
    if (isSearchSummary(searchVersion)) {
        return isSearchSharedToUser && isIncompleteState;
    }

    // Validate that there is at least one hit in a valid shared status
    const hasValidHit =
        "requestTerms" in searchVersion &&
        searchVersion?.requestTerms?.some((term) =>
            (term?.hits || [])?.some((hit) => hit?.sourceData.responsibleEmployeeId === context?.currentUser?.employeeId && validStatuses?.includes(hit?.status))
        );

    return isSearchSharedToUser && isIncompleteState && hasValidHit;
}
